import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { CopyIcon, Share2Icon, UserPlusIcon } from 'lucide-react';
import { BottomSheet } from './BottomSheet';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { business } from '../data/business';
import { copyText, pageUrl } from '../utils/contact';
interface ShareSheetProps {
  open: boolean;
  onClose: () => void;
  onSalvarContato: () => void;
  onToast: (mensagem: string) => void;
}
export function ShareSheet({
  open,
  onClose,
  onSalvarContato,
  onToast
}: ShareSheetProps) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (open) setUrl(pageUrl());
  }, [open]);
  const textoCompartilhar = `${business.nome} — ${business.especialidade}`;
  const handleCopiar = async () => {
    const ok = await copyText(url);
    onToast(ok ? 'Link copiado' : 'Não foi possível copiar');
  };
  const handleShareNativo = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: business.nome,
          text: textoCompartilhar,
          url
        });
        return;
      } catch {
        return;
      }
    }
    handleCopiar();
  };
  return <BottomSheet open={open} onClose={onClose} title="Compartilhar página" subtitle="Mostre o QR Code ou envie o link" data-id="element-141" data-mp="p0jww44138vm">
      <div className="mt-2 flex flex-col items-center rounded-2xl border border-shell bg-white p-6" data-id="element-142" data-mp="yrob31lvqppe">
        <div className="rounded-xl bg-white p-1" data-id="element-143" data-mp="21otyirnyiv7">
          {url && <QRCode value={url} size={168} fgColor="#2e261f" bgColor="#ffffff" data-id="element-144" data-mp="238ckg0sl605" />}
        </div>
        <p className="mt-4 text-center text-[12.5px] text-muted" data-id="element-145" data-mp="63iqqfyqn2q3">
          Aponte a câmera do celular para abrir esta página
        </p>
      </div>

      <div className="mt-4 flex items-center gap-2 rounded-2xl border border-shell bg-white/60 px-4 py-3" data-id="element-146" data-mp="g0wzruic0p8d">
        <span className="min-w-0 flex-1 truncate text-[13px] text-muted" data-id="element-147" data-mp="1mhs64kl05h4s">{url}</span>
        <button type="button" onClick={handleCopiar} className="flex shrink-0 items-center gap-1.5 rounded-full bg-sand px-3 py-1.5 text-[12px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-shell active:bg-shell focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-148" data-mp="1rg3eeqvnfjkw">
          <CopyIcon className="h-3.5 w-3.5" strokeWidth={1.7} data-id="element-149" data-mp="1bo1bxu9whm8u" />
          Copiar
        </button>
      </div>

      <div className="mt-3 grid grid-cols-3 gap-3" data-id="element-150" data-mp="j1q3jxg1yh1h">
        <button type="button" onClick={handleShareNativo} className="flex flex-col items-center gap-2 rounded-2xl border border-shell bg-white/60 px-3 py-4 text-[12px] font-medium text-ink transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-151" data-mp="j286fcx7ztid">
          <Share2Icon className="h-5 w-5 text-mocha" strokeWidth={1.5} data-id="element-152" data-mp="94cdqg3ben8" />
          Compartilhar
        </button>
        <a href={`https://wa.me/?text=${encodeURIComponent(`${textoCompartilhar} ${url}`)}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 rounded-2xl border border-shell bg-white/60 px-3 py-4 text-[12px] font-medium text-ink transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-153" data-mp="26zhcm899z1qg">
          <WhatsAppIcon className="h-5 w-5 text-mocha" data-id="element-154" data-mp="2up2094gdin62" />
          WhatsApp
        </a>
        <button type="button" onClick={onSalvarContato} className="flex flex-col items-center gap-2 rounded-2xl border border-shell bg-white/60 px-3 py-4 text-[12px] font-medium text-ink transition-colors duration-150 ease-out hover:border-mocha/30 hover:bg-white active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mocha" data-id="element-155" data-mp="2umphwq6peash">
          <UserPlusIcon className="h-5 w-5 text-mocha" strokeWidth={1.5} data-id="element-156" data-mp="1pjdhi4mb6dav" />
          Salvar contato
        </button>
      </div>
    </BottomSheet>;
}